import { render, staticRenderFns } from "./mainGear.vue?vue&type=template&id=32303835&scoped=true&"
import script from "./mainGear.vue?vue&type=script&lang=js&"
export * from "./mainGear.vue?vue&type=script&lang=js&"
import style0 from "./mainGear.vue?vue&type=style&index=0&id=32303835&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32303835",
  null
  
)

export default component.exports